export default __webpack_public_path__ + "static/media/ProductSans-Black.3999b85c.woff";